module.exports = __webpack_public_path__ + "static/ipaje-web.69792020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeSlider/img/ipaje-web.jpg
// module id = 101
// module chunks = 19817326959855 213534597649335 219805994829571